var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16.912,
    viewBox: "-0.1 -0.1 20 16.912",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 15629"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 16.912c-.1 0-.2-.02-.295-.062-.098-.043-2.429-1.073-4.791-2.927-1.405-1.103-2.53-2.27-3.34-3.47C.529 8.906 0 7.303 0 5.686 0 4.075.487 2.68 1.408 1.654 2.38.572 3.748 0 5.368 0 6.52 0 7.696.52 8.86 1.547c.46.406.847.829 1.14 1.183.293-.354.68-.777 1.14-1.183C12.304.52 13.479 0 14.632 0c1.62 0 2.988.572 3.96 1.654C19.513 2.68 20 4.074 20 5.687c0 1.617-.53 3.22-1.574 4.765-.81 1.2-1.935 2.368-3.34 3.471-2.362 1.854-4.693 2.884-4.791 2.927a.737.737 0 0 1-.295.062ZM5.368 1.47c-1.19 0-2.18.403-2.866 1.166-.675.751-1.031 1.806-1.031 3.05 0 5.265 6.993 8.935 8.528 9.677 1.535-.743 8.53-4.42 8.53-9.677 0-1.244-.356-2.299-1.032-3.05-.684-.763-1.675-1.166-2.865-1.166-1.967 0-3.765 2.519-3.964 2.806a.812.812 0 0 1-1.337 0C9.133 3.99 7.334 1.47 5.368 1.47Z",
    fill: "#fd6036",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 16.912c-.1 0-.2-.02-.295-.062-.098-.043-2.429-1.073-4.791-2.927-1.405-1.103-2.53-2.27-3.34-3.47C.529 8.906 0 7.303 0 5.686 0 4.075.487 2.68 1.408 1.654 2.38.572 3.748 0 5.368 0 6.52 0 7.696.52 8.86 1.547c.46.406.847.829 1.14 1.183.293-.354.68-.777 1.14-1.183C12.304.52 13.479 0 14.632 0c1.62 0 2.988.572 3.96 1.654C19.513 2.68 20 4.074 20 5.687c0 1.617-.53 3.22-1.574 4.765-.81 1.2-1.935 2.368-3.34 3.471-2.362 1.854-4.693 2.884-4.791 2.927a.737.737 0 0 1-.295.062ZM5.368 1.47c-1.19 0-2.18.403-2.866 1.166-.675.751-1.031 1.806-1.031 3.05 0 5.265 6.993 8.935 8.528 9.677 1.535-.743 8.53-4.42 8.53-9.677 0-1.244-.356-2.299-1.032-3.05-.684-.763-1.675-1.166-2.865-1.166-1.967 0-3.765 2.519-3.964 2.806a.812.812 0 0 1-1.337 0C9.133 3.99 7.334 1.47 5.368 1.47Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.2,
    stroke: "#fe6036",
    fill: "transparent"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFilled);
export default __webpack_public_path__ + "static/media/heartFilled.35930610c2fd0c5fa62a0d8490515827.svg";
export { ForwardRef as ReactComponent };